<template>
    <v-container fluid class="container-full-bg-gray">
        <app-row>
            <app-col cols="12">
                <v-card width="100%" class="rounded-10">
                    <v-card-title class="primary--text text--darken-2 px-5 pb-0 d-flex card-title-footer-color">
                        <span> 
                            <v-btn v-if="companydb_id" icon @click="$router.push({name: 'invoice-list', params: {'companydb_id': companydb_id}})">
                                <AppIcon :src="require('../../../assets/back-arrow.svg')" :size="29" />
                            </v-btn>
                            <span class="primary_blue--text ml-4">Registro de facturas</span>  
                        </span>
                        <v-row class="pa-0 ma-0">
                            <v-col cols="12" class="pa-0 ma-0">
                                <div class="d-flex align-center justify-space-between">
                                    <!-- Filtros -->
                                    <app-search-bar
                                        :filters="availableFilters"
                                        @updateObject="updateFilter"
                                        @resetAllFilters="removeAllFilt"
                                        :show_delete_filters="true"
                                    />
                                    <!-- Botón actualizar -->
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn @click="refreshList()" color="primary" icon v-bind="attrs" v-on="on"
                                                :loading="screen_data.loadingItems">
                                                <v-icon>mdi-refresh</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Actualizar</span>
                                    </v-tooltip>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-divider />
                    <v-card-text class="px-0 pt-0 card-title-footer-color">
                        <v-data-table
                            :items="screen_data.invoiceHistoryLogs"
                            :footer-items-per-page-text="screen_data.footerItemsPerPageText"
                            :footer-items-per-page-options="screen_data.footerItemsPerPageOptions"
                            :headers="screen_data.headers"
                            :loading="screen_data.loadingItems"
                            :server-items-length="screen_data.totalItems"
                            :footer-props="{
                                'items-per-page-text': screen_data.footerItemsPerPageText,
                                'items-per-page-options': screen_data.footerItemsPerPageOptions,
                            }"
                            :no-data-text="screen_data.textNoResults"
                            :loading-text="screen_data.textLoading"
                            :item-class="rowClass"
                            @update:items-per-page="changeLimit"
                            @update:page="changeOffset"
                            item-key="id"
                            @click:row="openInfoVisualizer"
                            height="600px"
                            fixed-header
                            >
                            <!-- Header -->
                            <template v-for="header in screen_data.headers" v-slot:[`header.${header.value}`]="{ }">
                                <span tabindex="0" :key="header.value">
                                    {{ header.text }}
                                </span>
                            </template>

                            <!-- Columnas -->
                            <template v-for="header in screen_data.headers" v-slot:[`item.${header.value}`]="{ item }">
                                <span class="font-color" :key="header.value">
                                    <span v-if="['total_base_amount', 'total_tax_amount', 'total_amount'].includes(header.value)">
                                        {{ item[header.value] }} €
                                    </span>
                                    <div v-else-if="header.value === 'info_verifactu'">
                                        <div class="error-cell-wrapper">
                                            <span
                                                class="status-dot"
                                                :class="dotClassInfoVerifactu(item.info_verifactu)"
                                                aria-hidden="true"
                                            ></span>
                                            <div class="error-cell" :title="item.info_verifactu">
                                                {{ item.info_verifactu }}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else-if="header.value === 'error_to_show'" class="error-cell" :title="item.error_to_show">
                                        {{ item.error_to_show || '-' }}
                                    </div>
                                    <span v-else>{{ item[header.value] }}</span>
                                </span>
                            </template>

                            <!--Footer: Paginación-->
                            <template v-slot:[`footer.page-text`]="items">
                                {{ items.pageStart }} - {{ items.pageStop }} de
                                {{ items.itemsLength }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
                <v-dialog 
                    v-model="info_visualizer_pop_up" 
                    max-width="1000" 
                    :eager="true" 
                    attach="body"
                    content-class="config-modal">
                    <EInvoiceHistoryLogInfo
                        @cancel="closeInfoVisualizer"
                        :record="selectedLog"
                    />
                </v-dialog>
            </app-col>
        </app-row>
    </v-container>
</template>

<script>
import AppBtn from "@/components/layout/AppBtn.vue";
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import AppSearchBar from "@/components/layout/AppSearchBar.vue";
import { VueInvoiceHistoryLogListScreenData } from "@/modules/facturae/infra/VueInvoiceHistoryLogListScreenData";
import { InvoiceHistoryLogListComponent } from "@/modules/facturae/app/InvoiceHistoryLogListComponent";
import { ApiHistoryLogRepository } from "@/modules/facturae/infra/HistoryLogRepositoryRepositories";
import EInvoiceHistoryLogInfo from "@/components/EInvoiceHistoryLogInfo.vue";


export default {
    name: "InvoiceHistoryLogList",
    components: {
        AppBtn,
        AppCol,
        AppRow,
        AppSearchBar,
        EInvoiceHistoryLogInfo,
    },
    data() {
        let screen_data = new VueInvoiceHistoryLogListScreenData();
        return {
            screen_data:screen_data,
            list_component: null,
            info_visualizer_pop_up: false,
            selectedLog: null,
            availableFilters: {
                error_verifactu: {
                    name: 'error_verifactu',
                    label: 'Error Verifactu',
                    icon: 'mdi-alert-circle',
                    type: 'select',
                    value: '',
                    text: '',
                    user_values: [
                        { text: 'Correcto', value: 'correcto' },
                        { text: 'Correcto con errores', value: 'correcto_con_errores' },
                        { text: 'Incorrecto', value: 'incorrecto' }
                    ]
                },
                // verifactu_status_code: {
                //     name: 'verifactu_status_code',
                //     label: 'Estado',
                //     icon: 'mdi-check-circle',
                //     type: 'select',
                //     value: '',
                //     text: '',
                //     user_values: [
                //         { text: 'Correcto', value: 2 },
                //         { text: 'Aviso', value: 1 },
                //         { text: 'Error', value: 0 }
                //     ]
                // },
                issuer_nif: {
                    name: 'issuer_nif',
                    label: 'CIF del Emisor',
                    icon: 'mdi-account',
                    type: 'text',
                    value: '',
                    text: ''
                }
            },
        };  
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    watch: { 
        companydb_id: function() {
            this.$router.push({ 'name': 'invoice-history-list', 'params': { 'companydb_id': this.companydb_id }})
            this.refreshList()
        }
    },
    async mounted() {
        const repo = new ApiHistoryLogRepository()
        this.list_component = new InvoiceHistoryLogListComponent(this.screen_data, repo, this.availableFilters);
        await this.list_component.mountList(this.companydb_id)
    },
    methods: {
        refreshList() {
            this.list_component.mountList(this.companydb_id)
            },
        changeLimit(limit) {
           this.list_component.changeLimit(limit, this.companydb_id)
        },
        changeOffset(offset) {
            this.list_component.changeOffset(offset, this.companydb_id)
        },  
        rowClass(item) {
            const code = item.verifactu_status_code
            if (code === 0) return 'row-verifactu-error'
            if (code === 1) return 'row-verifactu-warn'
            if (code === 2) return 'row-verifactu-ok'
            return ''
        },
        dotClass(code, msg) {
            // Sin mensaje => verde
            if (!msg || String(msg).trim() === '') return 'ok';
            if (code === 2) return 'ok';
            if (code === 1) return 'warn';
            return 'error';
        },
        dotClassInfoVerifactu(infoVerifactu) {
            if (infoVerifactu === 'Error') return 'error';
            if (infoVerifactu === 'Correcto') return 'ok';
            if (infoVerifactu === 'Enviada') return 'pending';
            if (infoVerifactu === 'Pendiente') return 'pending';
            if (infoVerifactu === 'Verifactu desactivado') return 'disabled';
            if (infoVerifactu && infoVerifactu.startsWith('Advertencia')) return 'warn';
            return 'pending';  // Valor por defecto
        },
        openInfoVisualizer(item) {
            this.selectedLog = item;
            this.info_visualizer_pop_up = true
        },
        closeInfoVisualizer() {
            this.info_visualizer_pop_up = false
        },
        updateFilter(data) {
            // Actualizar el valor del filtro en availableFilters
            const param = data.param || data;
            Object.values(this.availableFilters).forEach(element => {
                if (param.key === element.name) {
                    element.value = param.value;
                    element.text = param.text;
                }
            });
            // Resetear offset y recargar la lista
            this.screen_data.changeOffset(0);
            this.list_component.mountList(this.companydb_id);
        },
        removeAllFilt() {
            // Resetear todos los filtros
            Object.values(this.availableFilters).forEach(element => {
                element.value = '';
                element.text = '';
            });
            this.screen_data.changeOffset(0);
            this.list_component.mountList(this.companydb_id);
        }

    }
};
</script>

<style scoped>

::v-deep .v-card__title {
    padding-top: 15px !important;
    padding-bottom: 15px !important;

}
.card-title-footer-color {
    background: #fafaff;
}

::v-deep .v-data-footer {
    background-color: #fafaff;
    margin-right: 0px !important;
    padding-right: 17px;
}

::v-deep .v-data-table-header>tr>th {
    background-color: var(--v-primaryLight-base) !important;
}

::v-deep .v-data-table-header>tr>th>span,
::v-deep .v-data-table-header>tr>th>div>div>div>label>span {
    color: var(--v-primary-base);
    font-size: 0.875rem;
}

.font-color {
    color: #56565b;
}

::v-deep .v-data-table__wrapper>table>tbody>tr>td {
    border-bottom: none !important;
}


::v-deep .v-input__prepend-inner>div>i {
    color: var(--v-primary-base);
    top: 2px;
    padding-left: 5px;
}

.text-field-size {
    font-weight: normal;
    font-size: 0.875rem;
}

::v-deep .input-search .v-input__slot::before {
    border-style: none !important;
}

::v-deep .input-search .v-text-field__slot,
::v-deep .input-search .v-input__prepend-inner,
::v-deep .input-search .v-input__slot {
    background-color: #f2f1ff !important;
}

::v-card-title .title-dialog {
    justify-content: space-around;
}

.autocomplete_field {
    border: solid 1px;
    border-color: var(--v-primary-base);
    color: transparent !important;
    height: 50px !important;
    margin: 0;
    padding: 0;
}

.acction_btns {
    display: flex !important;
    justify-content: space-between !important;
    padding: 0 36px 20px;
}

.action__btn {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    border-radius: 20px;
    padding: 18px !important;
    gap: 8px;
    text-transform: capitalize;
}


.cancel_button {
    border: 1px solid var(--v-primary-base);
    background-color: white !important;
    color: var(--v-primary-base);
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.accept_button {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-primary-base) !important;
    color: white;
    padding: 20px !important;
    font-size: 20px;
    text-transform: none !important;
}

.btn-right {
    display: flex;
    justify-content: flex-end;
}

.no-underline>>>.v-text-field .v-input__control>.v-input__slot:before {
    border: none;
}
.rounded-10 {
    border-radius: 10px !important;
}

.primary_blue--text {
    color: var(--v-primary_blue-base) !important;
    font-size: 20px;
    font-weight: 500;
}

.error-cell {
  display: -webkit-box;
  -webkit-line-clamp: 4;       
  line-clamp: 4;               
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;          
  line-height: 1.35;
  max-width: 280px;             
}


::v-deep .v-data-table td,
::v-deep .v-data-table .v-data-table__td {
  vertical-align: top;
}


::v-deep .v-data-table .row-verifactu-ok > td    { background-color: #EEFFEE !important; }
::v-deep .v-data-table .row-verifactu-warn > td  { background-color: #FFFFEA !important; }
::v-deep .v-data-table .row-verifactu-error > td { background-color: #FFF0D5 !important; }

::v-deep .v-data-table tbody tr.row-verifactu-ok > td {
  background-color: #EEFFEE !important; 
  color: #fff !important;
}

::v-deep .v-data-table tbody tr.row-verifactu-warn > td {
  background-color: #FFFFEA !important; 
  color: #5D4037 !important;
}

::v-deep .v-data-table tbody tr.row-verifactu-error > td {
  background-color: #FFF0D5 !important; 
  color: #fff !important;
}

.error-cell-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 8px;
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex: none;
    margin-top: 4px;
}

.status-dot.ok   { background-color: #2E7D32; }
.status-dot.warn { background-color: #FFB300; }
.status-dot.error{ background-color: #E65100; }
.status-dot.pending { background-color: #9E9E9E; }
.status-dot.disabled { background-color: #BDBDBD; }


::v-deep .v-data-table tbody tr:hover > td {
  background-color: #EFEAF5 !important;
}


::v-deep .v-chip .v-chip__content {
  font-weight: normal !important;
}

::v-deep .v-chip__content span {
  font-weight: normal !important;
}

::v-deep .v-chip {
  font-weight: normal !important;
}

</style>
<style>

.v-overlay__content.config-modal,
.v-overlay__content.config-modal::before,
.v-overlay__content.config-modal::after,
.v-dialog__content.config-modal,
.v-dialog__content.config-modal::before,
.v-dialog__content.config-modal::after {
  background: transparent !important;
  box-shadow: none !important;
  filter: none !important;        
  border-radius: 0 !important;    
}


.v-overlay__content.config-modal > .v-dialog,
.v-dialog__content.config-modal  > .v-dialog {
  background: transparent !important;
  box-shadow: none !important;
  filter: none !important;
  border-radius: 0 !important;
}


.v-overlay__content.config-modal .v-sheet.v-card,
.v-dialog__content.config-modal  .v-sheet.v-card,
.v-overlay__content.config-modal > .v-dialog > .v-card,
.v-dialog__content.config-modal  > .v-dialog > .v-card {
  box-shadow: none !important;
  border-radius: 28px !important;
  overflow: hidden;
}
</style>
